module.exports = __webpack_public_path__ + "static/media/logo.25c0ecb9.png";